<template>
    <div class="TelVerificationCheck">
        <div>
            <span style="color:red;font-weight: bold;">*</span>
            <span class="subtitle ">電　話 ：</span>
            <div class="d-flex my-2">
                <select class="mr-2" id="phone-select">
                    <option v-for="item in PhoneData" :value="item.phoneCode">{{item.displayName}}</option>
                </select>
                <input type="text" class="flex-fill" v-model="phone" size="15"/>
            </div>
            <div class="GoGetVer"  @click="GetVerification()" v-if="!GetVerIng">取得驗證碼</div>
            <div v-if="GetVerIng"  class="GoGetVerCountDown">
                <span>重發驗證碼：{{ CountDownSeconds }}秒</span>
            </div>
        </div>
        <div class="d-flex align-items-center  justify-content-left my-2">
            <span style="color:red;font-weight: bold;">*</span>
            <span class="subtitle" style="margin:0px 2px 8px 2px;width:30%;">驗證碼：</span>
            <input type="text" class="" v-model="VerificationCode" @blur="VerBlurEvent" size="12"/>
            <font-awesome-icon class="mx-1" style="color: green" :icon="['far','circle-check']" v-if="TelCkeck" />
            <font-awesome-icon class="mx-1" style="color: red" :icon="['far','circle-xmark']" v-if="telWrong" />
        </div>
    </div>
</template>

<script>
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'

export default {
    name: 'TelVerificationCheck',
    components:{
    },
    props:[
    ],
    data () {
        return {
            Token : '',
            GetVerIng : false,
            phone : '',
            TelCkeck : false,
            telWrong : false,
            VerificationCode : '',
            TrueVerCode : '',
            CountDownSeconds:180,
            PhoneData:[],
        }
    },
    methods:{
        VerBlurEvent(){
            if(this.VerificationCode.trim() == '' || this.TrueVerCode.trim() == ''){
                this.TelCkeck = false;
                this.telWrong = false;
            }else if(this.VerificationCode.trim() == this.TrueVerCode.trim()){
                this.TelCkeck = true;
                this.telWrong = false;
            }else{
                this.TelCkeck = false;
                this.telWrong = true;
            }
            
            var selectElement = document.querySelector('#phone-select');
            var selectedOption = selectElement.selectedOptions[0];
            var phoneCode = selectedOption.value;
            var displayName = selectedOption.textContent;

            var telVerList = {
                phone : this.phone,
                TelCkeck : this.TelCkeck,
                VerificationCode : this.VerificationCode,
                phoneCode:phoneCode,
                phoneCodeDisplayName:displayName,
            }
            
            this.$emit('update:telVerList', telVerList)
        },
        //計時器設定
        tick () {
            this.CountDownSeconds -=1;
            
            if (this.CountDownSeconds === 0) {
                clearInterval(this.timer)
                this.GetVerIng = false;
            }
        },
        //取得電話驗證碼
        GetVerification(){
            if(this.phone.trim() != ''){
                this.CountDownSeconds = 180;
                this.timer = setInterval(this.tick.bind(this),1000);
                //登入驗證-輸入email及密碼
                const api =`${process.env.APIPATH}/api/Member/GetVerification`;
                const inputdata = 
                {
                    "Phone":this.phone,
                    "ContactType":1,
                };
                this.GetVerIng = true;

                axios.post(api, inputdata)
                    .then((response) => {
                        if(response.data.isSuccess){ 
                            this.TrueVerCode = response.data.verificationCode;
                        }else{
                            console.error(response.data.message);
                            alert(response.data.message);
                        }
                    })
                    .catch(error => {
                        this.errorMessage = error.message;
                        console.error("There was an error!", error);
                    });
            }else{
                alert("請輸入電話號碼")

            }
        },
        //取得城市電話
        GetCityCode(){
            const api =`${process.env.APIPATH}/api/Information/GetCityCode`;
            const inputdata = {};

            axios.post(api, inputdata)
                .then((response) => {
                    if(response.data.isSuccess){ 
                        this.PhoneData = response.data.phoneData;
                    }else{
                        console.error(response.data.message);
                        alert(response.data.message);
                    }
                })
                .catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
    },
    created(){
        this.GetCityCode();
    },
}
</script>




// WEBPACK FOOTER //
// src/components/LineComponents/TelVerificationCheck.vue